import Vue from 'vue';

// helper components
import '../application/components/Helpers/HelperComponent';

// components
Vue.component('app-login', require('./components/views/Auth/Login').default);
Vue.component('app-password-reset', require('./components/views/Auth/PasswordReset').default);
Vue.component('app-reset-password', require('./components/views/Auth/ResetPassword').default);
Vue.component('app-confirm-invitation', require('./components/views/Auth/ConfirmInvitation').default);
Vue.component('app-navbar-view', require('./components/Layouts/Navbar').default);
Vue.component('app-sidebar-view', require('./components/Layouts/Sidebar').default);

// Client components
Vue.component('client-nav-bar', require('./components/Layouts/ClientNavBar').default);
Vue.component('client-footer', require('./components/Layouts/ClientFooter').default);
Vue.component('client-footer', require('./components/Layouts/ClientFooter').default);
Vue.component('comment', require('./components/views/Client/feed/Comment').default);

// Client pages
Vue.component('client-page-feed', require('./components/views/Client/feed/Feed').default);
Vue.component('client-page-profile', require('./components/views/Client/profile/Profile').default);
Vue.component('client-page-profile-read-only', require('./components/views/Client/profile/ProfileReadOnly').default);
Vue.component('client-page-gallery', require('./components/views/Client/profile/Gallery').default);
Vue.component('client-page-gallery-read-only', require('./components/views/Client/profile/GalleryReadOnly').default);

Vue.component('general-setting', require('./components/views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./components/views/Settings/EmailSetting').default);
Vue.component('notification-settings', require('./components/views/Settings/Notification/Settings/Index').default);
Vue.component('personal-information', require('./components/views/Auth/PersonalInformation').default);
Vue.component('password-change', require('./components/views/Auth/PasswordChange').default);
Vue.component('social-links', require('./components/views/Auth/SocialLinks').default);
Vue.component('broadcast-setup', require('./components/views/Settings/BroadcastSetup').default);

// users and roles
Vue.component('group-of-users', require('./components/views/UserRoles/Roles/GroupOfUsers').default);

// notification
Vue.component('database-template', require('./components/views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./components/views/Settings/Notification/Template/MailTemplate').default);

//Pages
Vue.component('page-dashboard', require('./components/views/Dashboard').default);
Vue.component('page-profile', require('./components/views/Auth/Profile').default);
Vue.component('page-users-roles', require('./components/views/UserRoles/Index').default);
Vue.component('page-settings', require('./components/views/Settings/Index').default);
Vue.component('page-notification', require('./components/views/Auth/Notification').default);
Vue.component('page-teams', require('./components/views/Team/Teams').default);

// Update
Vue.component('app-update', require('./components/views/Update/template/Update').default);
Vue.component('app-manual-updater', require('./components/views/Update/template/ManualUpdater').default);
Vue.component('app-update-confirmation-modal', require('./components/views/Update/template/UpdateConfirmationModal').default);